import { render, staticRenderFns } from "./ProofItem.vue?vue&type=template&id=7021844a&scoped=true"
import script from "./ProofItem.vue?vue&type=script&lang=js"
export * from "./ProofItem.vue?vue&type=script&lang=js"
import style0 from "./ProofItem.vue?vue&type=style&index=0&id=7021844a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021844a",
  null
  
)

export default component.exports